import { render } from "./DefultLayout.vue?vue&type=template&id=f03244de"
import script from "./DefultLayout.vue?vue&type=script&lang=js"
export * from "./DefultLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__